
/*
 * Date: 2025
 * Description: Users rows reworked for table
 * Author: Philippe Leroux @ Skitsc
 */

//Modules
import { Box , Grid , Typography , IconButton , Tooltip } from "@mui/material"
import { ReactElement } from "react"

//Interfaces && types
import { i_table_row_props } from "../../interfaces/utility.interface";
import { i_user } from "../../interfaces/user.interface";

//Icons
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import UpdateIcon from '@mui/icons-material/Update';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PersonIcon from '@mui/icons-material/Person';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

//Utils
import { timestampToDate } from "../../utils/utility";

const UserRow = ( props : i_table_row_props) : ReactElement => {
    const ReturnType = ( row : i_user ) => {
        return (
            <Tooltip title={row.type}>
                <IconButton>
                    {row.type === 'admin' ? <AdminPanelSettingsIcon /> :  <EmojiPeopleIcon/> }
                </IconButton>
            </Tooltip>
        )
    }
    const R = props.row
    const H = props.headers
    return (
        <Box sx={{ borderLeft : '1px solid #D3D3D3' , borderRight : '1px solid #D3D3D3' , borderBottom : '1px solid #D3D3D3'}}>
            <Grid container sx={{ padding : '6px'}}>
                <Grid size={H[0].portion} sx={{ opacity : R.disabled ? 0.5 : 1}}>
                    <Box sx={{ display : 'flex' , marginTop : '0.4vh' ,opacity : R.disabled ? 0.5 : 1 }}>
                        <Typography sx={{ fontSize : 14 }}>{timestampToDate(R.timestamp , 'long')}</Typography>
                    </Box>
                </Grid>
                <Grid size={H[1].portion} sx={{ alignSelf : 'center'}}>
                    <Typography sx={{ alignSelf : 'center' , fontSize : 14 , opacity : R.disabled ? 0.5 : 1}}>{R.username}</Typography>
                </Grid>
                <Grid size={H[2].portion} sx={{ alignSelf : 'center' , display : 'flex'}}>
                    <Typography sx={{ alignSelf : 'center' , fontSize : 14 , opacity : R.disabled ? 0.5 : 1}}>{R.email}</Typography>
                </Grid>
                <Grid size={H[3].portion} sx={{ alignSelf : 'center' , opacity : R.disabled ? 0.5 : 1}}>
                {<ReturnType {...R} />}
                </Grid>
                <Grid size={H[4].portion} sx={{ alignSelf : 'center' }}>
                    <Tooltip title={"Edit"}>
                        <IconButton sx={{ opacity : !R.active ? 0.5 : 1}} onClick={() => R.disable ? {} :  props.callback(R , 'form')}><UpdateIcon color={'primary'}/></IconButton>
                    </Tooltip>
                    <Tooltip title={R.disabled ? 'Enable' : 'Disable'}>
                        <IconButton sx={{ opacity : 1}} onClick={() => props.callback(R , 'disable')}>
                            {R.active ?<PersonOffIcon color={'primary'}/> : <PersonIcon color={'primary'}/>}
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={'WARNING delete this user'}>
                        <IconButton sx={{ opacity : !R.active ? 0.5 : 1}} onClick={() => R.disable ? {} : props.callback(R , 'delete')}>
                            <DeleteForeverIcon/>
                        </IconButton>
                    </Tooltip>
                </Grid>
          
            </Grid>
        </Box>
    )
}

export default UserRow